// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
import { Controller } from "@hotwired/stimulus"

import { getOptions, onChange, onSelect, onClear, updateMembersCount } from "../helpers/select2.js"

// require('select2/dist/js/select.js');
// require('select2/dist/css/select.css');
import { sendFilter } from "../helpers/filter.js"

import select2 from 'select2/dist/js/select2'

import Rails from "@rails/ujs"
// https://github.com/pascallaliberte/stimulus-turbolinks-select2/blob/master/_assets/controllers/multi-select_controller.js

export default class extends Controller {
  static targets = [ "select" ]

  connect() {
    if (this.selectTargets.length > 0) {
      this.selectTargets.forEach((el) => {
        this.select2mount($(el))
        document.addEventListener('turbolinks:before-cache', () => {
          this.select2unmount($(el))
        }, {once: true})
      })
    }
  }

  select2unmount(theSelect) {
    if ($(theSelect).data('select2')) {
      $(theSelect).select2('destroy')
    }
  }

  select2mount(theSelect) {

    let options = {}
    let searchFormEl = document.querySelector('.search')
    let isSearchEl = (searchFormEl) ? searchFormEl.contains(theSelect.get( 0 )) : false

    if (isSearchEl) {
      theSelect.on('select2:select select2:clear', (e) => {
        e.preventDefault()
        e.stopImmediatePropagation()

        sendFilter(theSelect)
      })
    }

    if (theSelect.data('template-selection-name')) {
      options['templateSelection'] = (item) => {        
        if (item.id == "") { return item.text }
        if (!item.element.dataset[theSelect.data('template-selection-name')]) {
          item.element.dataset[theSelect.data('template-selection-name')] = item[theSelect.data('template-selection-name')]
        }

        let _result = $(item[theSelect.data('template-selection-name')] || item.element.dataset[theSelect.data('template-selection-name')])

        if (_result.length > 0) {
          return _result
        } else {
          return item.text
        }

      }
    }

    if (theSelect.data('template-result-name')) {
      options['templateResult'] = (item) => {
        if (item.id == "") { return item }
        return $(item[theSelect.data('template-result-name')])
      }
    }


    if (theSelect.data('endpoint')) {

      options['dataAdapter'] = $.fn.select2.amd.require(theSelect.data('adapter-func'))

      options['ajax'] = {
        dataType: 'json',
        delay: 250,
        cache: true,
        transport: (params, success, failure) => {
          getOptions(theSelect, params, success)
        },
        processResults: function (data, params) {
          return { results: data }
        }
      }
    }

    if (theSelect.data('modal')) {
      options['dropdownParent'] = $(`#${theSelect.data('modal')}`)
    }

    theSelect.select2(options)

    theSelect.on('select2:unselecting', function() {
      $(this).data('unselecting', true)
    }).on('select2:opening', function(e) {
      if ($(this).data('unselecting')) {
        $(this).removeData('unselecting')
        e.preventDefault()
      }
    })

    // if (theSelect.data('editable')) {
    //   let el = $(theSelect)
    //   let htmlEl = $(theSelect).next()
    //   let searchEl = htmlEl.find('.select2-search__field')
    //   let slectionEls = htmlEl.find('.select2-search__field')
    //   let els = []

    //   if(!htmlEl.hasClass("select2--with-text-mode")){
    //     htmlEl.addClass("select2--with-text-mode")
    //   }

    //   htmlEl.append("<i class='fas fa-pencil-alt select2--text-mode-btn'></i>")

    //   htmlEl.find('.select2--text-mode-btn').click(function() {
    //     if ($(theSelect).select2('data').length > 0) {
    //       $(theSelect).select2('data').forEach(element => els.push(element.text))
    //       el.val(null).trigger('change')
    //       searchEl.val(els.join(', '))
    //       els = []
    //     }
    //   })

    // }


    if (theSelect.data('hidden')) {
      theSelect.next(".select2-container").hide()
    }

    if (theSelect.data('drophide')) {
      
      theSelect.on('select2:opening', (e) => {
        e.preventDefault()
      })

      let htmlEl = $(theSelect).next()
      let selEl = htmlEl.find('.select2-selection')

      selEl.on('keyup', (e) => {
        if(e.keyCode == '13'){
          let sEl = $(e.currentTarget).find('.select2-search__field')
          let val = sEl.val()
          
          if (theSelect.select2('data').filter(e => e.text === val).length > 0) {
            
          } else {
            // Create a DOM Option and pre-select by default
            var newOption = new Option(val, val, true, true);
            // Append it to the select
            theSelect.append(newOption).trigger('change');
          }
          sEl.val('')
          e.preventDefault()
        }
      })
    }
    
    theSelect.on('select2:selecting', (e) => {
      if (theSelect.data('on-select')) {
        onSelect(e, theSelect.data('on-select'))
      }
    })

    theSelect.on('select2:clear', (e) => {
      if (theSelect.data('on-clear')) {
        onClear(e, theSelect.data('on-clear'))
      }
    })

    theSelect.on('change.select2', (e) => {

      if (theSelect.data('on-change')) {
        if (e.namespace == "") {
          onChange(e, theSelect.data('on-change'))
        }
      }

      if (theSelect.data('mirror')) {
        const mirror_el = $(theSelect.data('mirror'))
        const subj = $(e.target)
        const value = subj.val()
        const data = subj.select2('data')

        if (value) {

          if (theSelect.data('endpoint')) {
            mirror_el.empty()

            data.forEach((el) => {
              if (el.id != "") {
                mirror_el.append(el.element.cloneNode(true))
              }
            })
          }

          mirror_el.val(value)
          mirror_el.trigger('change.select2')
        } else {
          if (theSelect.data('endpoint')) {
            mirror_el.empty()
          } else {
            mirror_el.val(null).trigger('change.select2')
          }
        }
      }

      if (e.namespace == "") {
        this.element.querySelectorAll('.select2').forEach((target) => {
          if (`#${e.target.id}` == target.getAttribute('data-related')) {
            if (target.getAttribute('data-related-type') != 'dont_clear_on_parent_change') {
              $(target).val(null).trigger('change')
            }
          }
        })
      }

    })
    
    if (theSelect.data('mirror')) {
      theSelect.trigger('change.select2')
    }

    if (theSelect.data('init-with-on-change')) {
      onChange({currentTarget: theSelect[0]}, theSelect.data('on-change'))
    }

  }

  update_teams_count(e) {
    updateMembersCount("gt_tournament_all_teams_select")
  }
  update_players_count(e) {
    updateMembersCount("gt_tournament_all_players_select")
  }

}
